import useModal from 'src/hooks/useModal'
import Modal from '../Modal/Modal'
import ModalHeader from '../Modal/ModalHeader'
import { useEffect } from 'react'

const IframeModal = () => {
  const { data, handleClose, isOpen } = useModal('iframe')

  useEffect(() => {
    if (isOpen && (!data?.sourceUrl || !data?.title)) {
      console.error('IframeModal: No sourceUrl or title provided')
      handleClose()
      return
    }
  }, [data?.sourceUrl, data?.title, isOpen])

  return (
    <Modal modalName="iframe" classes={{ paper: 'w-4/5 h-4/5' }}>
      <ModalHeader title={data?.title as string} />
      <iframe
        className="h-[calc(100%_-_80px)] w-full rounded-b-lg border-none"
        src={data?.sourceUrl as string}
        sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
        referrerPolicy="no-referrer"
        title={data?.title as string}
      />
    </Modal>
  )
}

export default IframeModal
